import { complianceInfoReducer } from 'src/app/compliance/store/reducers/compliance-info.reducers';
import { compliancePermissionsReducer } from 'src/app/compliance/store/reducers/compliance-permissions.reducers';
import { complianceReportReducer } from 'src/app/compliance/store/reducers/compliance-report.reducers';
import { contractsReducer } from 'src/app/compliance/store/reducers/contracts.reducers';
import { documentBatchDetailsReducer } from 'src/app/compliance/store/reducers/document-batch-details.reducers';
import { documentReviewerReducer } from 'src/app/compliance/store/reducers/document-reviewer.reducers';
import { postedGroupedDocumentsReducer } from 'src/app/compliance/store/reducers/posted-documents-grouped.reducers';
import { complianceRequestsReducer } from './compliance-requests.reducers';
import { complianceRequirementDescriptionsReducer } from './compliance-requirement-descriptions.reducers';
import { facilitiesReducer } from './facilities.reducers';
import { matchGroupReducer } from './match-group.reducers';
import { professionSpecialtyConfigurationReducer } from './profession-specialty-configuration.reducer';
import { qmAssociationsReducer } from './qm-associations.reducer';
import { scheduleOrientationPermissionReducer, scheduleOrientationReducer } from './schedule-orientation.reducers';
import { shippingRequestsReducer } from './shipping-requests.reducers';
import { stateLicensureReducer } from './state-licensure.reducers';
import { stateRequirementReducer } from './state-requirement.reducers';
import { vendorAdminReducer } from './vendor-admin.reducers';
import { metadataConfigurationReducer } from './metadata-configuration.reducers';
import { requirementOverrideReducer } from './requirement-override.reducers';
import { complianceReportReducerNew } from './compliance-report-new.reducers';
import { complianceMetadataReducer } from './compliance-metadata.reducers';
import { stateSelectedStateArgsReducer } from './state-selected-state-args.reducers';

export const complianceReducers = {
    complianceInfo: complianceInfoReducer,
    contracts: contractsReducer,
    documentReviewer: documentReviewerReducer,
    documentBatchDetails: documentBatchDetailsReducer,
    postedDocumentsGrouped: postedGroupedDocumentsReducer,
    matchGroup: matchGroupReducer,
    facilities: facilitiesReducer,
    qmAssociations: qmAssociationsReducer,
    complianceReport: complianceReportReducer,
    stateLicensure: stateLicensureReducer,
    stateRequirements: stateRequirementReducer,
    selectedStateArgs: stateSelectedStateArgsReducer,
    compliancePermissions: compliancePermissionsReducer,
    shippingRequests: shippingRequestsReducer,
    vendorAdmin: vendorAdminReducer,
    complianceRequests: complianceRequestsReducer,
    scheduleOrientation: scheduleOrientationReducer,
    scheduleOrientationPermission: scheduleOrientationPermissionReducer,
    requirementDescriptions: complianceRequirementDescriptionsReducer,
    professionSpecialtyConfiguration: professionSpecialtyConfigurationReducer,
    metadataConfiguration: metadataConfigurationReducer,
    requirementOverride: requirementOverrideReducer,
    complianceReportNew: complianceReportReducerNew,
    complianceMetadata: complianceMetadataReducer
};
